import React, { useState, useEffect, useCallback } from 'react';
import {
  DASHBOARD_THEME_STORAGE_KEY,
  getStoredDashboardTheme,
  setStoredDashboardTheme,
  applyDashboardThemeToDocument,
  emitDashboardThemeChange,
} from '../utils/dashboardTheme';

/**
 * Appearance block for role dashboards: toggles global `html.theme-dark` (see App.css).
 */
export default function DashboardAppearanceSettings({ style }) {
  const [dark, setDark] = useState(() => getStoredDashboardTheme() === 'dark');

  const apply = useCallback((isDark) => {
    const mode = isDark ? 'dark' : 'light';
    setDark(isDark);
    setStoredDashboardTheme(mode);
    applyDashboardThemeToDocument(mode);
    emitDashboardThemeChange(mode);
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== DASHBOARD_THEME_STORAGE_KEY) return;
      if (e.newValue === 'dark') {
        setDark(true);
        applyDashboardThemeToDocument('dark');
        emitDashboardThemeChange('dark');
      } else if (e.newValue === 'light') {
        setDark(false);
        applyDashboardThemeToDocument('light');
        emitDashboardThemeChange('light');
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <div className="settings-card dashboard-appearance-card" style={style}>
      <h3>Appearance</h3>
      <p className="dashboard-appearance-desc">
        Dark theme for this portal (saved on this device). Applies to owner, tenant, realtor, professional, and admin dashboards.
      </p>
      <div className="setting-item">
        <div className="setting-info">
          <span className="setting-label">Dark theme</span>
          <span className="setting-desc">Easier on the eyes in low light</span>
        </div>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={dark}
            onChange={(e) => apply(e.target.checked)}
            aria-label="Enable dark theme for dashboard"
          />
          <span className="toggle-slider" />
        </label>
      </div>
    </div>
  );
}
